import React, { Fragment } from "react"
import useStyle from '../../../hooks/useStyle'
import useSort from '../../../hooks/useSorting'
import Cs from "../../../services/CommonService"
import ConfirmMenu from "../../Modals/ConfirmMenu"
import useModal from "../../../hooks/useModal"
import { Table, THead, TH, TR, TD, TBody } from "../../Common/TableView"
import { PhoneIcon, MapIcon, LinkMapIcon, LinkMailIcon, LinkUserIcon, LinkDeleteIcon, LinkFontAwesomeIcon, FontAwesomeIcon2 } from "../../Common/ImageIcons"
import { DraftBadge } from "../../Common/NotificationPill"
import { NotificationBadge } from "../../Common/BadgePill"
import { RecordId, MCJDetails, MCJDetails_2, AddressRequired } from "./Common"
import { NotificationPopup } from "../../Common/NotificationPopup"
import Rating from '../../Common/Rating'
import {DropMenu, DropMenuItem} from "../../Common/MenuItem"

const JourneyTable = (props) => {
  useStyle('table');  

  const {journeyList} = props;
 
  const tableData = journeyList.map((j, k) => {
    if(j.journey_type === 'infant_journey'){
      return(
        <StartupRow journey={j}/>
      )
    }

    return <StartupRow journey={j} {...props}/>
  })

  return (
    <Fragment>
      <div className="app-content-section app-section-2 table-fix-head m-t-30">
        <Table className="shadow-small" id="journey">
          <THead>
            <TR>
              <TH>
                ID
              </TH>
              <TH>
                Name
              </TH>
              <TH>
                Location
              </TH>
              <TH>
                Actions
              </TH>
            </TR>
          </THead>
          <TBody>
            {tableData}
          </TBody>
        </Table>
      </div>
    </Fragment>
  )
}

const StartupRow = ({journey, openJourneyProfileFormModal, addComments, onDelete}) => {
  return (
    <TR>
      <TD className="text-gray wk-center">
        <RecordId journey={journey}/>
      </TD>
      <TD>
        <MCJDetails journey={journey}/>
      </TD>
      <TD>
        <MCJDetails_2 journey={journey}/>
      </TD> 
      <TD>
        <div className="flex coldir aligncenter rgap-5 pointer">
          <LinkFontAwesomeIcon
            tooltip="Edit"
            onSelect={() => openJourneyProfileFormModal(journey)}
            iconCss="fas fa-pen white"/>
              
          <LinkFontAwesomeIcon
            tooltip="Add Comments"
            onSelect={() => addComments(journey)}
            iconCss="fas fa-comments white" />
                
          <LinkDeleteIcon id="delete" 
            tooltip="Delete journeyProfile" 
            onSelect={() => onDelete(journey)} />
        </div>  
      </TD>
    </TR>
  )
}

export default JourneyTable;